import { useCallback } from 'react';
import { Link, useParams, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import ErrorMessageBox from '../components/ErrorMessageBox';
import { Pagination } from '../components/Pagination';
import MeetingTalk from './partials/MeetingTalk';
import { scrollToElement } from '../../lib/userFunctions';
import { useQuery } from "@tanstack/react-query";
import Api, { createFetchErrorMessage } from 'utils/api/Api';
import useQueryString from 'utils/hooks/useQueryString';
import { Loading } from "app/components/Loading";


export const AuthorMeetingListByUser = () => {
    const navigate = useNavigate();
    const { school } = useParams();
    const { page } = useQueryString();
    const auth = useSelector(state => state.auth);

    const { data: fetchMyMeetingList, isFetching, isError, error } = useQuery({
        queryKey: ['my/meting/list', page || 0],
        queryFn: () => Api.get(`/api/meeting/list/my?page=${page || 0}&size=1`)
    });

    const fetchList = useCallback((page = 0) => {
        scrollToElement("lnb");
        navigate(`/${school}/user/${auth.id}/activity/meeting?page=${page}`);
    }, [auth, navigate, school]);

    if (isError) return <ErrorMessageBox message={createFetchErrorMessage(error).message} />;

    return (
        <div className="subpage">
            <div id="contents" className="myreading_meeting readingActivityItem">
                <div className="inner">
                    <div className="activity_list meeting_writer bdT0">
                        {(fetchMyMeetingList?.data?.list.length <= 0) && <div className="no_data">목록이 없습니다.</div>}
                        {
                            fetchMyMeetingList?.data?.list.map((item, key) => {
                                console.log(item);
                                return (
                                    <div className="row" key={key}>
                                        <div className="col3">
                                            <div className="book_wrap">
                                                <Link to={`/${school}/book/${item.meeting.book.isbn}`}>
                                                    <div className="book_cover">
                                                        <div className="book_inner">
                                                            <img src={item.meeting.book?.image} alt={item.meeting.title} />
                                                            <div
                                                                className={`service service_${item.meeting.book.isService.toLowerCase()}`}
                                                            ></div>
                                                        </div>
                                                    </div>
                                                </Link>
                                                <div className="book_info">
                                                    <p className="title">{item.meeting.book.title}</p>
                                                    <p className="writer">{item.meeting.book.author}</p>
                                                    <p className="pb_company">{item.meeting.book.publisher}</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col9">
                                            <MeetingTalk meeting={item.meeting} meetingUser={item.meetingUser} readOnly={true} />
                                        </div>
                                    </div>
                                );
                            })
                        }
                        <Loading overlay={true} active={isFetching} />

                        <Pagination page={fetchMyMeetingList?.data?.page} totalPage={fetchMyMeetingList?.data?.totalPages} gotoPage={fetchList} />
                    </div>
                </div>
            </div>
        </div>
    );
};